export type TPartnerProgramCode =
  | 'P1 Spec'
  | 'P1 HW'
  | 'P1 Sup'
  | 'BP'
  | 'Ret H1'
  | 'Ret H2'
  | 'BP banned'

export interface IOfferingCompleteness {
  Offering: string
  Completeness: number
}

export interface IP360Status {
  PartnerType: string
  Offerings: IOfferingCompleteness[]
}

const initialData = {
  AddressLine1: '',
  AddressLine2: '',
  AddressLine3: '',
  City: '',
  CommunicationName: '',
  CompanyLegalName: '',
  ContactID: '',
  Country: '',
  CountryOfBusiness: '',
  Email: '',
  EmailCompany: '',
  EntryID: '',
  FirstName: '',
  Gender: '',
  IsPerfectMatch: 0,
  HPPassportProfileID: '',
  HierarchyType: '',
  Hierarchy_Type: '',
  LastContactUpdateDate: '',
  LastName: '',
  LastPartnerUpdateDate: '',
  LearnerID: '',
  LocationID: '',
  LoginID: '',
  MainPhone: '',
  MobilePhone: '',
  NeverCall: '',
  NeverEmail: '',
  OLD_ContactID: '',
  OLD_PartnerID: '',
  Organization: '',
  ParentPartnerID: '',
  PartnerID: '',
  PortalUserTypeCode: '',
  PreferredLanguage: '',
  PrimaryJobRole: '',
  ProfessionalTitle: '',
  Salutation: '',
  Seniority: '',
  State: '',
  Status: '',
  TaxID: '',
  TopPartnerID: '',
  URL: '',
  UserCreatedDate: '',
  UserLastLoginDate: '',
  UserRowID: '',
  UserStatus: '',
  WorkPhone: '',
  ZIPCode: '',
  programCodes: [] as TPartnerProgramCode[],
  highlightWords: [] as string[],
  HPD_Contact_GUID: '',
  HPD_Partner_GUID: '',
  BasicInfoCompleteness: '',
  ContactInfoCompleteness: '',
  DeviceInfoCompleteness: '',
  MarketInfoCompleteness: '',
  ActionsPlanCompleteness: '',
  CompletenessTotal: '',
  Completeness: '',
  P360Status: '',
}

export type TSearchItem = typeof initialData

export const create = (data?: Partial<TSearchItem>): TSearchItem => ({
  ...initialData,
  ...data,
})
